/* global axios */

import ApiClient from './ApiClient';

class TiktokLeadSettingsAPI extends ApiClient {
  constructor() {
    super('tiktok/lead_settings', { accountScoped: true });
  }
}

export default new TiktokLeadSettingsAPI();
